module.exports = __webpack_public_path__ + "img/logo-dorfbox-full-white.f32cd6ed.png";